<template>
    <div class="center content-inputs">
        <vs-input :loading="loading" v-model="query" placeholder="بحث "/>
         <div class="gallery" v-if="items.data">
           <div class="row justify-content-center animate__animated animate__fadeInUp my-3">
      <vs-button @click="loadMore" v-if="items.next_page_url !=null" color="rgb(211, 186, 127)" flat gradient
        :loading="loading" size="large">
        الصفحة التالية
      </vs-button>
    </div>
            <VueJustifiedLayout :items="items.data" v-if="!loading"
                   :options="{
  containerPadding: 5,
  forceAspectRatio: 0,
  fullWidthBreakoutRowCadence:0,
  showWidows: false,
  targetRowHeight:250,
  boxSpacing:3
}"
            >
            <template slot-scope="{ item, index }">
                <router-link :to="{
            name: 'details',
            params: { id: item.id },
            query: {
              image: item.image,
              height: item.height,
              width: item.width,
              pres: (item.height / item.width) * 100,
            },
          }" @click.native="close(item)" class="cursor-pointer">
                   <img :src="'https://pic.imamhussain.org/photos/preview/' + item.image" width="100%"
                        class="animate__animated animate__fadeIn" :style="`animation-delay:.${index}s`" alt="search"/>
               
                
                </router-link>
            </template>
        </VueJustifiedLayout>
          <div class="row justify-content-center animate__animated animate__fadeInUp my-3">
      <vs-button @click="loadMore" v-if="items.next_page_url !=null" color="rgb(211, 186, 127)" flat gradient
        :loading="loading" size="large">
        الصفحة التالية
      </vs-button>
    </div>
         </div>
      
    </div>
</template>
<script>
    export default {
        props:['q'],
        data() {
            return {
                page: 1,
                category: 0,
                user: 0,
                sort: 'add_desc',
                limit: 10,
                featured: 0,
                pic_week: 0,
                query: '',
                loader: false,
                loading: false,
                items: [],
                timer: null
            }
        },
        created() {
            if(this.q !=null){
                this.query=this.q;
            }
        },
        watch: {
            page(){
                this.search()
            },
            query() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.search();
                }, 200);
            }
        },
        methods: {
            loadMore(){
                 if (this.items.next_page_url !=null) {
                     this.page++;
                 }
            },
            search() {
                this.loader = false;
                this.loading = true;
             // this.items=[];
                fetch(
                        `https://pic.imamhussain.org/index.php/api/v2/photos?page=${this.page}&category=${this.category}&user=${this.user}&sort=${this.sort}&limit=${this.limit}&featured=${this.featured}&pic_week=${this.pic_week}&search=${this.query}`)
                    .then(res => res.json()).then(res => {
                        this.items = res
                        this.loader = true;
                        this.loading = false;
                    });
            },
            close(item){
                
                this.$emit('close',item);
            }
        },
    }
</script>
<style lang="scss">
    // .gallery{
    //     overflow-y: auto;
    //     height:500px;
    // }
    .vs-dialog--scroll .vs-dialog__content {
    max-height: calc(100vh - 110px) !important;
 }
 .vs-input__label {
     right: 13px !important;
     left:0px !important;
 }
 .vs-input {
     width: 100% !important;
 }
 .vs-dialog {
     max-width: 60vw !important;
     width: 80vw;
 }
</style>